import { Injectable, inject } from '@angular/core';
import {
	Router,
	CanActivateFn,
	CanActivateChildFn,
	ActivatedRouteSnapshot,
	RouterStateSnapshot
} from '@angular/router';
import { KeycloakService } from '@shared/services/api';
import { NgxPermissionsService } from 'ngx-permissions';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class AuthGuardService {
	private readonly router = inject(Router);
	private readonly authService = inject(KeycloakService);
	private readonly permissionsService = inject(NgxPermissionsService);

	canActivate(): Observable<boolean> {
		if (!this.authService.getAccessToken()) {
			this.authService.logout();
			return of(false);
		}

		const userRole = Object.keys(this.permissionsService.getPermissions());

		if (userRole.length > 0) {
			return of(true);
		}

		return this.authService.getUser().pipe(
			map((user) => {
				const role =
					user.authorities.length > 0 ? user.authorities.map((auth) => auth.authority) : [];

				if (role.length > 0) {
					this.permissionsService.addPermission(role);
					return true;
				} else {
					console.debug('here')
					this.router.navigateByUrl('/auth/access');
					return false;
				}
			}),
			catchError(() => {
				console.debug('here')
				this.router.navigateByUrl('/auth/access');
				return of(false);
			})
		);
	}
}

// Standalone functional guards for use in routes
export const authorizedGuard: CanActivateFn = (
	route: ActivatedRouteSnapshot,
	state: RouterStateSnapshot
) => {
	return inject(AuthGuardService).canActivate();
};

export const authorizedChildGuard: CanActivateChildFn = (
	childRoute: ActivatedRouteSnapshot,
	state: RouterStateSnapshot
) => {
	return authorizedGuard(childRoute, state);
};
